import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbSecurityModule } from '@nebular/security';
import { FilterSelectModule } from '../../core/utils/filter-select/filter-select.module';
import { MaterialModule } from '../../shared/material-module';
import { LicensesModule } from '../licenses/licenses.module';
import { OrganisationDetailsComponent } from './organisation-details/organisation-details.component';
import { OrganisationUsersComponent } from './organisation-details/organisation-users/organisation-users.component';
import { OrganisationEditDialogComponent } from './organisation-edit/organisation-edit-dialog.component';
import { OrganisationEditPageComponent } from './organisation-edit/organisation-edit-page.component';
import { OrganisationEditComponent } from './organisation-edit/organisation-edit.component';
import { OrganisationsRoutingModule } from './organisations-routing.module';
import { OrganisationsComponent } from './organisations.component';

export { OrganisationsComponent, OrganisationEditComponent };

@NgModule({
  imports: [
    OrganisationsRoutingModule,
    CommonModule,
    FilterSelectModule,
    FormsModule,
    LicensesModule,
    MaterialModule,
    NbSecurityModule,
    ReactiveFormsModule
  ],
  declarations: [
    OrganisationsComponent,
    OrganisationEditComponent,
    OrganisationEditDialogComponent,
    OrganisationEditPageComponent,
    OrganisationDetailsComponent,
    OrganisationUsersComponent
  ],
  exports: [
    OrganisationsComponent,
    OrganisationDetailsComponent,
    OrganisationUsersComponent
  ]
})
export class OrganisationsModule {}
